/* eslint-disable camelcase */
import ApiClient from '@/api/ApiClient';

import type {
  LabelTranslation,
  TranslationCreateRequest,
  TranslationRecord,
} from '../models';

export type CopyTranslationsRequest = {
  from_table?: string;
  from_tenant_id?: string;
  to_table?: string;
  to_tenant_id?: string;
};

export class TranslationClient {
  apiClient: ApiClient;

  constructor(apiClient?: ApiClient) {
    this.apiClient = apiClient || ApiClient.instance;
  }

  updateTranslationByLabelId(request: { id: string; body?: LabelTranslation; }): Promise<void> {
    const { id, body } = request;
    return this.apiClient.put({
      path: `/api/i18n/labels/${id}/translations`,
      body,
    });
  }

  getTranslationMap(): Promise<Record<string, string>[]> {
    return this.apiClient.get({
      path: '/api/i18n/translations',
    });
  }

  updateTranslation(request: { body?: LabelTranslation; } = {}): Promise<void> {
    const { body } = request;
    return this.apiClient.put({
      path: '/api/i18n/translations',
      body,
    });
  }

  addTranslations(request: { body?: TranslationRecord[]; } = {}): Promise<void> {
    const { body } = request;
    return this.apiClient.post({
      path: '/api/i18n/translations/addTranslations',
      body,
    });
  }

  getAllTranslationsMap(): Promise<Record<string, string>[]> {
    return this.apiClient.get({
      path: '/api/i18n/translations/all',
    });
  }

  copyTranslations(request: CopyTranslationsRequest = {}): Promise<void> {
    const { ...params } = request;
    return this.apiClient.post({
      path: '/api/i18n/translations/copy',
      params,
    });
  }

  createOrUpdateLabelAndTranslations(request: { body?: TranslationCreateRequest; } = {}): Promise<void> {
    const { body } = request;
    return this.apiClient.post({
      path: '/api/i18n/translations/create',
      body,
    });
  }

  deleteTranslations(request: { body?: string[]; } = {}): Promise<void> {
    const { body } = request;
    return this.apiClient.post({
      path: '/api/i18n/translations/deleteTranslations',
      body,
    });
  }

  getTranslations(): Promise<LabelTranslation[]> {
    return this.apiClient.get({
      path: '/api/i18n/translations/export',
    });
  }

  getTenantTranslations(): Promise<LabelTranslation[]> {
    return this.apiClient.get({
      path: '/api/i18n/translations/tenant/export',
    });
  }

  uploadTranslations(): Promise<void> {
    return this.apiClient.post({
      path: '/api/i18n/translations/upload',
    });
  }

  createTranslationFiles(request: { languages: string; }): Promise<void> {
    const { languages } = request;
    return this.apiClient.post({
      path: `/api/i18n/translations/${languages}`,
    });
  }
}

export default TranslationClient;
